import React from "react";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";

import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RecordVoiceOverOutlinedIcon from "@material-ui/icons/RecordVoiceOverOutlined";

import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";

const { BRAND_NAME } = process.env;

const ProHowItWorks = () => {
	const classes = useStyles("Pro");

	const { h2, head_1, subhead_1, head_2, subhead_2, head_3, subhead_3 } =
		useConstants("ProHowItWorksViewModel");

	return (
		<>
			<Box
				component="section"
				className={classes.hiwWrapper}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"center"}
			>
				<Container maxWidth={false} className={classes.proContainer}>
					<h2 className={classes.joinH2}>{h2}</h2>

					<Grid container spacing={8}>
						<Grid item xs={12} sm={12} md={4}>
							<div className={classes.stepBox}>
								<AddCircleOutlineIcon className={classes.hiwIcon} />

								<h3 className={classes.joinH3}>{head_1}</h3>

								<p className={classes.joinBodyText}>{subhead_1}</p>
							</div>
						</Grid>

						<Grid item xs={12} sm={12} md={4}>
							<div className={classes.stepBox}>
								<RecordVoiceOverOutlinedIcon className={classes.hiwIcon} />

								<h3 className={classes.joinH3}>{head_2}</h3>

								<p className={classes.joinBodyText}>{subhead_2}</p>
							</div>
						</Grid>

						<Grid item xs={12} sm={12} md={4}>
							<div className={classes.stepBox}>
								<VerifiedUserOutlinedIcon className={classes.hiwIcon} />
								<h3 className={classes.joinH3}>{head_3}</h3>
								<p className={classes.joinBodyText}>{subhead_3}</p>
							</div>
						</Grid>
					</Grid>
				</Container>
			</Box>
			{/* <Box
				component="section"
				className={classes.hiwWrapper}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"center"}
			>
				<Container maxWidth={false} className={classes.proContainer}>
					<h2 className={classes.joinH2}>{`How ${BRAND_NAME} works`}</h2>

					<Grid container spacing={8}>
						<Grid item xs={12} sm={12} md={4}>
							<div className={classes.stepBox}>
								<LooksOneIcon className={classes.hiwIcon} />

								<h3 className={classes.joinH3}>Create a free profile</h3>

								<p className={classes.joinBodyText}>
									{`Get in front of customers when they’re searching for businesses
								like yours on ${BRAND_NAME}. Build a winning profile by adding reviews, pictures, and prices.`}
								</p>
							</div>
						</Grid>

						<Grid item xs={12} sm={12} md={4}>
							<div className={classes.stepBox}>
								<LooksTwoIcon className={classes.hiwIcon} />

								<h3 className={classes.joinH3}>Decide what jobs you want</h3>

								<p className={classes.joinBodyText}>
									{`Let us know the types of jobs you want. Then, we'll send your business valuable customers that match your criteria.`}
								</p>
							</div>
						</Grid>

						<Grid item xs={12} sm={12} md={4}>
							<div className={classes.stepBox}>
								<Looks3Icon className={classes.hiwIcon} />
								<h3 className={classes.joinH3}>
									Start booking jobs from new customers
								</h3>
								<p
									className={classes.joinBodyText}
								>{`All jobs come with the customer's phone number and details. Plus, customers pay you directly, and we don't take a cut.`}</p>
							</div>
						</Grid>
					</Grid>
				</Container>
			</Box> */}
		</>
	);
};

export default ProHowItWorks;
